import { z } from 'zod';


const createSpecialLeaveBaseSchema = z.object({
  employeeTargetId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:specialLeave.validation.employeeRequired' })
      .int()
      .positive('absence:specialLeave.validation.employeeRequired'),
    z.null(),
  ]),
  specialLeaveTypeId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:specialLeave.validation.specialLeaveTypeRequired' })
      .int()
      .positive('absence:specialLeave.validation.specialLeaveTypeRequired'),
    z.null(),
  ]),
  startDate: z
    .string()
    .min(1, 'absence:specialLeave.validation.startDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:specialLeave.validation.invalidDateFormat'),
  endDate: z.string().optional().default(''),
  workdayType: z.string().min(1, 'absence:specialLeave.validation.workdayTypeRequired'),
  dayCount: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:specialLeave.validation.dayCountRequired' })
      .int('absence:specialLeave.validation.dayCountInteger')
      .positive('absence:specialLeave.validation.dayCountRequired'),
    z.null(),
  ]),
  returnDate: z.string().optional().default(''),
  detail: z
    .union([z.string().max(300, 'absence:specialLeave.validation.detailMaxLength'), z.null()])
    .optional()
    .default(null)
    .transform((value) => value ?? ''),
});

export const createSpecialLeaveFormSchema = createSpecialLeaveBaseSchema
  .refine((data) => data.employeeTargetId !== null, {
    message: 'absence:specialLeave.validation.employeeRequired',
    path: ['employeeTargetId'],
  })
  .refine((data) => data.specialLeaveTypeId !== null, {
    message: 'absence:specialLeave.validation.specialLeaveTypeRequired',
    path: ['specialLeaveTypeId'],
  })
  .refine((data) => data.dayCount !== null, {
    message: 'absence:specialLeave.validation.dayCountRequired',
    path: ['dayCount'],
  });

export type CreateSpecialLeaveFormValues = z.infer<typeof createSpecialLeaveFormSchema>;
